import * as tslib_1 from "tslib";
import { Component, Watch, Mixins } from 'vue-property-decorator';
import FiltersBase from './filtersBase';
import Results from './components/Results.vue';
import Filters from './components/Filters.vue';
import Help from "./Help";
import * as cpfHelp from './cpf.help';
var Settings = cpfHelp.Settings;
import * as responsiveKey from './responsiveKey';
import Popup from './popup';
import Autocomplete from '@trevoreyre/autocomplete-vue';
import '@trevoreyre/autocomplete-vue/dist/style.css';
import VueDraggableResizable from 'vue-draggable-resizable';
import { SpsApiResult, getSpsCarParks, searchMbResultsAndSpsSites, mbToAutoCompleteResult } from '@/help.search';
import { getPinInfo } from '@/help.filters';
import "./styles.less";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
const token = 'pk.eyJ1IjoiYmNhbWVyb25zbWl0aCIsImEiOiJjazkydDNreXIwNGcxM2RtdndzM3p0a3Y0In0.Zd_a3O2c52fBSCIt14iQ4g';
const makeSearchLessUseful = false;
const limitCarParksResultsDisplay = 30;
function createIcon(name) {
    const icon = L.icon({
        iconRetinaUrl: require(`./assets/pins/${name}_2x.png`),
        iconUrl: require(`./assets/pins/${name}.png`),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        iconSize: [44, 50],
        iconAnchor: [22, 50],
        popupAnchor: [0, -32]
    });
    delete icon._getIconUrl;
    return icon;
} //Now putting a marker with this icon on a map is easy://L.marker([51.5, -0.09], { icon: greenIcon }).addTo(map);
const debounce2 = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            timeout = null; // null timeout to indicate the debounce ended
            func(...args); // Execute the callback
        };
        clearTimeout(timeout); // This will reset the waiting every function execution. This is the step that prevents the function from being executed because it will never reach the inside of the previous setTimeout
        timeout = setTimeout(later, wait); // Restart the debounce waiting period.setTimeout returns a truthy value (it differs in web vs Node)
    };
};
let App = class App extends Mixins(FiltersBase) {
    constructor() {
        super(...arguments);
        this.debounceHandler = debounce2(this.doFiltering, 250); //was 450 stop user hammering filtering with normal clicking filters etc / panning map etc
        this.combinedResults = true; ///TODO:TD remove, for debugging totggle between MBApi and both
        this.currentBounds = L.latLngBounds(L.latLng(52.200479, -3.025207), L.latLng(52.202571, -3.021529));
        this.markers = cpfHelp.getEmptyMarkerClusterGroup();
        this.mapLoaded = false;
        this.pinsLoaded = false;
        this.isFiltering = true;
        this.dataLoaded = false;
        this.parentToUnspiderify = null;
        this.selectedMarkerId = 0;
        this.selectedResult = null;
        this.resultsListForDisplayCalcCounts = 0;
        this.initialSearchTerm = "";
        this.autoSelectGeocodeResult = false;
        this.autoSelectedResult = null;
        this.initialId = 0;
        this.areaManagerFilterId = null; // areaManagerFilterId: number = 0;// areaManagerFilterId: number | null = null;
        this.selectedIsSticky = false;
        this.allCarParks = [];
        //these are filtered by filter buttons only
        this.filteredCarParks = [];
        this.filteredCarParksMarkers = [];
        this.resultsList = [];
        this.webSocialShareShown = false;
        this.windowHeight = window.innerHeight;
        this.windowWidth = window.innerWidth;
        this.width = 0;
        this.height = this.mapAndResizerInitialHeight;
        this.x = 0;
        this.y = 0;
    }
    //lifecycles
    created() {
        this.setInitialSearchTerm(); //ronseal
        this.getCarParks(); //finally calls this.setupAllCarParkPins()
    }
    mounted() {
        this.getMap(); //??
        this.setupAllCarParkPins(); //??
        if (!Help.isNullOrEmpty(this.initialSearchTerm)) {
            console.log(`mounted`);
            this.$refs.autocompleteref.$refs.input.focus(); //https://github.com/trevoreyre/autocomplete/issues/15 hideResults ?
            //const activeTextarea = document.activeElement;
        }
        this.$nextTick(() => {
            window.addEventListener('resize', this.onWindowResize);
        });
    }
    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
        if (this.map) {
            this.map.remove(); //https://stackoverflow.com/questions/42816517/cant-load-leaflet-inside-vue-component
        }
    }
    //methods //methods //methods //methods //methods //methods //methods //methods //methods //methods //methods //methods
    clearFilters() {
        this.filters.forEach(f => f.reset()); //this.filters.forEach(f => { f.selected = false; f.disabled = false; });
    }
    resultShareClick(id) {
        this.webSocialShareShown = true;
    }
    webShareClosed() {
        this.webSocialShareShown = false;
    }
    selectResult(id) {
        this.selectedMarkerId = id;
        var mId = this.filteredCarParksMarkers.filter(x => x.id === id)[0];
        if (!mId.marker._icon) {
            this.parentToUnspiderify = mId.marker.__parent;
            this.parentToUnspiderify.spiderfy(); //leaves open when closed... we could perhaps zoom instead like zoomToBoundsOnClick ?
        }
        if (Help.isNullOrUndef(mId.marker))
            console.log("marker was null could not open poupup");
        mId.marker.openPopup(); //else?
    }
    toggleSelectedResult(id, fromMarkerClick = false) {
        if (this.selectedMarkerId === id)
            this.selectedMarkerId = 0;
        else
            this.selectResult(id);
    }
    isSelected(id) {
        return this.selectedMarkerId === id;
    }
    doFiltering() {
        this.resultsList = this.calcResultsList();
        this.isFiltering = false;
        if (this.initialId > 0 && this.resultsList.length > 0) {
            this.$nextTick(function () {
                try {
                    this.toggleSelectedResult(this.initialId);
                }
                catch (error) {
                    console.log("cp id not found : " + this.initialId);
                }
                this.initialId = 0;
            });
        }
    }
    setupAllCarParkPins() {
        if (!this.pinsLoaded && this.allCarParks.length > 0 && this.mapLoaded) {
            this.setPinsForFilteredCarParks();
            this.map.addLayer(this.markers);
            this.pinsLoaded = true;
            if (this.autoSelectedResult != null) {
                console.log(`setupAllCarParkPins`);
                this.autocompleteSubmit(this.autoSelectedResult);
                this.autoSelectedResult = null;
            }
            this.setupResults();
        }
    }
    setPinsForFilteredCarParks() {
        var msToRemove = this.filteredCarParksMarkers.filter(x => !this.filteredCpsIds.includes(x.id)); //align this.filteredCarParksMarkers with this.filteredCarParks//add or remove markers as necessary
        var markersToRemove = msToRemove.map((x) => x.marker);
        this.markers.removeLayers(markersToRemove);
        msToRemove.forEach((x) => {
            Help.removeItemFromArray(this.filteredCarParksMarkers, x);
        });
        var msToAdd = this.filteredCarParks.filter(x => !this.markersCpsIds.includes(x.id));
        var markersToAdd = [];
        msToAdd.forEach((cp) => {
            try {
                const icon = createIcon(getPinInfo(cp).pinType); //TODO:BCS confirm this is not bad perf
                var marker = L.marker(cpfHelp.carParkToLocation(cp), { title: cp.name, icon: icon, });
                marker.bindPopup(Popup.createPopup(cp));
                marker.off('click');
                marker.on('click', (a) => {
                    this.toggleSelectedResult(cp.id, true); //TODO:scroll the result in list into view - if it's being shown !!! pass a bool to toggleSelectedResult for "fromMarkerClick"
                });
                this.filteredCarParksMarkers.push({ id: cp.id, marker: marker });
                markersToAdd.push(marker);
            }
            catch (e) {
                console.log(`${cp.id} ${cp.name} ${e}`);
            }
        });
        this.markers.addLayers(markersToAdd);
    }
    calcResultsList() {
        if (this.pinsLoaded) {
            if (this.anyFiltersSelected)
                this.filteredCarParks = this.allCarParks.filter(x => cpfHelp.containsAllItems(x.filters, this.filtersSelected));
            else
                this.filteredCarParks = this.allCarParks.slice();
            if (this.areaManagerFilterIdValid)
                this.filteredCarParks = this.filteredCarParks.filter(x => x.areaManagerId == this.areaManagerFilterId);
            let sw = this.currentBounds.getSouthWest();
            let ne = this.currentBounds.getNorthEast();
            return this.filteredCarParks.filter(x => x.latitude <= ne.lat && x.latitude >= sw.lat
                && x.longitude <= ne.lng && x.longitude >= sw.lng);
        }
        return [];
    }
    geoCode(input) {
        return new Promise(resolve => {
            this.autoSelectedResult = null;
            let url = "";
            if (makeSearchLessUseful)
                url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(input)}.json?access_token=${token}&cachebuster=1593958895616&autocomplete=true&country=gb&types=region,postcode,district,place,locality,neighborhood,address`;
            else
                url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(input)}.json?access_token=${token}&cachebuster=1593958895616&autocomplete=true&country=gb`;
            if (input.length < 3)
                return resolve([]);
            else {
                //console.log(`Getting Places from MBox for "${input}"...`);
                fetch(url)
                    .then(response => response.json())
                    .then(data => {
                    //console.log(`MBox gave us ${data.features.length} results for "${input}"`);//should prob see if can use the place_type address, postcode, place etc and the "bbox" in the results to help choose zoom level?
                    if (this.autoSelectGeocodeResult) { //TODO:TD query search this is WRONG, means searching from pm.co.uk  home, or elsewhere will ONLY ever give Mapbox API results !
                        //console.log(`autoSelectGeocodeResult`); https://trello.com/c/J2duyc0H/37-cpf-query-search
                        if (data.features.length > 0) {
                            console.log(`setting autoSelectedResult`);
                            this.autoSelectedResult = mbToAutoCompleteResult(data.features[0]); //need to convert to common type?
                            console.log(this.autoSelectedResult);
                        }
                        this.autoSelectGeocodeResult = false;
                    }
                    else
                        console.log(`NOT autoSelectGeocodeResult`);
                    if (this.combinedResults) {
                        var res = searchMbResultsAndSpsSites(data.features, this.filteredCarParks, input);
                        console.log(`SEARCH GOOD`);
                        resolve(res);
                    }
                    else {
                        console.log(data.features.map((r) => r.relevance)); //0-1 https://docs.mapbox.com/api/search/geocoding-v5/#mapboxplaces
                        resolve([]);
                    }
                });
            }
        });
    }
    getAutocompleteResultValue(result) {
        if (result.name == null)
            console.log(`result ${result}`);
        return result.name;
    }
    autocompleteSubmit(result) {
        if (result.isSps) {
            this.map.once('zoomend', () => {
                setTimeout(() => {
                    console.log("zoomend isSps");
                    this.selectResult(result.id); //  this.selectResult(((result as any) as SpsApiResult).id)
                }, 300); //we use a timeout in addition to the leaflet.js event handlers, otherwise seems some timing clash and end up without spiderified and popup
            });
        }
        cpfHelp.flyToResult(result, this.map); //could pass another param here, if from querystring auto search - so can be less zoomed e.g. 14 or so = more results?
    }
    setInitialSearchTerm() {
        let query = this.getUrlParameter('query');
        let cpId = this.getUrlParameter('id');
        let amId = this.getUrlParameter('amId');
        if (!Help.isNullOrEmpty(query)) {
            this.initialSearchTerm = query;
            this.autoSelectGeocodeResult = true;
        }
        else if (!Help.isNullOrEmpty(cpId) && Help.canConvertToNumber(cpId)) {
            var idToSet = parseInt(cpId, 10);
            this.initialId = idToSet;
        }
        else if (!Help.isNullOrEmpty(amId) && Help.canConvertToNumber(amId)) {
            var amIdToSet = parseInt(amId, 10);
            this.areaManagerFilterId = amIdToSet;
        }
    }
    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' ')); //.replace(/\+/g, ' ') replaces + with space
    }
    getCarParks() {
        getSpsCarParks().then(rs => {
            this.allCarParks = rs.map(c => new SpsApiResult(c)); // (rs as any);
        }).finally(() => {
            this.dataLoaded = true;
            this.setupAllCarParkPins();
        });
    }
    getMap() {
        this.map = L.map('map_inner', { worldCopyJump: true, zoomControl: false }); //this.map = L.map('map_inner', { worldCopyJump: true }); //TODO:KEY option 2
        this.map.setView([Settings.mapDefaultLat, Settings.mapDefaultLng], Help.getResponsiveMapZoomDefault()); // Settings.mapZoomDefault);
        this.map.options.minZoom = Help.getResponsiveMapMinZoomLevel(); //Settings.mapMinZoomLevel;
        this.currentBounds = this.map.getBounds();
        this.map.on('moveend', () => { this.currentBounds = this.map.getBounds(); }); //TODO:our off for results is why map bounds stop working to refliter here
        cpfHelp.setBaseLayers(this.map);
        L.control.zoom({
            position: 'topright'
        }).addTo(this.map); // (this.map as any)._layersMaxZoom = 19; //https://github.com/Leaflet/Leaflet.markercluster/issues/611
        this.mapLoaded = true;
        responsiveKey.getResponsiveKey(this.map);
        this.setupAllCarParkPins();
    }
    setupResults() {
        this.isFiltering = true;
        this.debounceHandler(); //doFiltering
    }
    onCurrentBoundsChanged(value, oldValue) {
        //console.log(`this.currentBounds ${this.currentBounds}`);
        //console.log(`getZoom() ${this.map.getZoom()}`);
        this.setupResults();
    }
    onFiltersSelectedChanged(value, oldValue) {
        this.setupResults();
    }
    onFilteredCarParksChanged(value, oldValue) {
        var idsNow = value.map((cp) => cp.id);
        var idsOld = oldValue.map((cp) => cp.id);
        let actuallySame = (idsNow == '' + idsOld);
        if (!actuallySame)
            this.setPinsForFilteredCarParks();
    }
    onWindowResize() {
        this.windowHeight = window.innerHeight;
        this.windowWidth = window.innerWidth;
    }
    onResize(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    onDrag(x, y) {
        this.x = x;
        this.y = y;
    }
    //computed //computed//computed//computed//computed//computed//computed//computed//computed//computed//computed
    get areaManagerFilterIdValid() {
        return Help.isGoodNumber(this.areaManagerFilterId);
    }
    get resizable() {
        return this.windowWidth < 600; //@narrow: ~ "screen and (max-width: 600px)";
    }
    get searchPlaceholder() {
        if (this.resizable)
            return "Parking or Place (postcode, address etc)";
        return "Parking or Places (postcode, address etc)";
    }
    get maxHeight() {
        return this.windowHeight - 73;
    }
    get mapAndResizerInitialHeight() {
        return (this.windowHeight - 73) / 2;
    }
    get mapHeight() {
        if (this.resizable)
            return ((this.windowHeight - 73 - this.height) + 12); // this.mapAndResizerInitialHeight + 10;// (this.windowHeight - 73 - this.height);// + 10; //10 allows map to be taller than should so curved border works
        else
            return this.windowHeight - 50; //@main_height: calc(100vh - @header_height);
    }
    get resultsSubtitle() {
        if (!this.isWaiting) {
            let amFilterNote = "";
            if (this.areaManagerFilterIdValid) {
                if (this.filteredCarParks.length > 0) {
                    var name = this.filteredCarParks[0].areaManagerFullName;
                    amFilterNote = ` - AreaManager ${name}`;
                }
            }
            if (Help.arrayAllEqual([this.resultsList.length, this.filteredCarParks.length, this.allCarParks.length]))
                return `Showing all ${this.allCarParks.length} car parks${amFilterNote}`;
            else if (Help.arrayAllEqual([this.resultsList.length, this.filteredCarParks.length]))
                return `${this.resultsList.length} matching filters, ${this.allCarParks.length} Total${amFilterNote}`;
            else if (Help.arrayAllEqual([this.filteredCarParks.length, this.allCarParks.length]))
                return `${this.resultsList.length} mapped, ${this.allCarParks.length} Total${amFilterNote}`;
            return `${this.resultsList.length} mapped, ${this.filteredCarParks.length} match filters, ${this.allCarParks.length} Total${amFilterNote}`;
        }
        return "Please wait...";
    }
    get isWaiting() {
        return !this.dataLoaded || this.isFiltering;
    }
    get resultsListForDisplay() {
        var alphabeticallySorted = this.resultsList.slice().sort((a, b) => {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0; // a must be equal to b
        }).slice(0, limitCarParksResultsDisplay);
        if (this.selectedMarkerId > 0) { //ensure selected item is NOT in the results and set selectedResult instead
            var selectedItem = Help.singleOrNull(alphabeticallySorted, r => r.id === this.selectedMarkerId);
            if (selectedItem === null)
                selectedItem = Help.singleOrNull(this.filteredCarParks, r => r.id === this.selectedMarkerId);
            else
                Help.removeItemFromArray(alphabeticallySorted, selectedItem);
            if (selectedItem !== null)
                this.selectedResult = selectedItem;
            else
                this.selectedMarkerId = 0;
        }
        return alphabeticallySorted;
    }
    get resultsListForDisplayNotEmpty() {
        return this.selectedMarkerId > 0 ? ((this.resultsListForDisplay.length + 1) > 0) : (this.resultsListForDisplay.length > 0);
    } //maybe just use this.resultsList.length instead which DOES seem to match what's on screen
    get markersCpsIds() {
        return this.filteredCarParksMarkers.map((cpm) => cpm.id);
    }
    get filteredCpsIds() {
        return this.filteredCarParks.map((cpm) => cpm.id);
    }
};
tslib_1.__decorate([
    Watch('currentBounds')
], App.prototype, "onCurrentBoundsChanged", null);
tslib_1.__decorate([
    Watch('filtersSelected')
], App.prototype, "onFiltersSelectedChanged", null);
tslib_1.__decorate([
    Watch('filteredCarParks')
], App.prototype, "onFilteredCarParksChanged", null);
App = tslib_1.__decorate([
    Component({
        components: {
            Autocomplete,
            VueDraggableResizable,
            Filters,
            Results
        }
    })
], App);
export default App;
